import { PropTypes } from 'prop-types'

import { LeftSideContainer, RightSideContainer, LayoutContainer } from './styles'

import {
  ArrowsAlignedTop,
  AttributesCounterComponent,
  SpaghettiOverlayWithLogoComponent,
  ExplainerWithIconsComponent,
  PeopleWithLogoLeftComponent,
} from './components'

export const UNAUTHENTICATED_BACKGROUND_KEYS = {
  arrowsAlignedTop: 'arrowsAlignedTop',
  peopleWithLogo: 'peopleWithLogo',
  explainerWithIcons: 'explainerWithLogo',
  attributesCounter: 'attributesCounter',
  spaghettiOverlayWithLogo: 'spaghettiOverlayWithLogo',
  createAccountExplainer: 'createAccountExplainer',
}

const UnauthenticatedLayout = ({ children, backgroundKey, sidebarChildren = null }) => {
  const UNAUTHENTICATED_BACKGROUNDS = {
    [UNAUTHENTICATED_BACKGROUND_KEYS.arrowsAlignedTop]: ArrowsAlignedTop,
    [UNAUTHENTICATED_BACKGROUND_KEYS.peopleWithLogo]: PeopleWithLogoLeftComponent,
    [UNAUTHENTICATED_BACKGROUND_KEYS.explainerWithIcons]: ExplainerWithIconsComponent,
    [UNAUTHENTICATED_BACKGROUND_KEYS.attributesCounter]: AttributesCounterComponent,
    [UNAUTHENTICATED_BACKGROUND_KEYS.spaghettiOverlayWithLogo]: SpaghettiOverlayWithLogoComponent,
  }

  const LeftSideComponent = UNAUTHENTICATED_BACKGROUNDS[backgroundKey]
  return (
    <LayoutContainer>
      <LeftSideContainer className="sticky-top">
        <LeftSideComponent>{sidebarChildren}</LeftSideComponent>
      </LeftSideContainer>
      <RightSideContainer>{children}</RightSideContainer>
    </LayoutContainer>
  )
}

UnauthenticatedLayout.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundKey: PropTypes.oneOf(Object.values(UNAUTHENTICATED_BACKGROUND_KEYS)).isRequired,
  sidebarChildren: PropTypes.node,
}

export default UnauthenticatedLayout
